import * as types from "../../actions/dashboard/actionTypes";
import initialState from "../initialState";

export default function dashboardReducer(state = initialState.dashboard, action) {
  switch (action.type) {
    // case types.LOAD_UPCOMING_RESERVATIONS:
    //   return {
    //     ...state,
    //     ...action.data,
    //   };

    case types.LOAD_RESERVATIONS:
      const data = action.data ?? {};

      const reservation_type = data.reservation_type ?? "";
      const bookings = data.db_res?.bookings ?? [];
      const pagination = data.db_res?.pagination ?? 0;

      const _reservations = {
        ...state.reservations,
        [reservation_type]: {
          bookings,
          pagination,
        },
      };

      return {
        ...state,
        bookings: _reservations,
      };

    case types.LOAD_REVIEWS:
      return {
        ...state,
        userReviews: {
          ...state.userReviews,
          [action.data.type]: {
            reviews: action.data.db_res.reviews,
            pagination: action.data.db_res.pagination,
          },
          countsByType: action.data.db_res.meta.countsByType,
        },
      };

    case types.LOAD_EDIT_REVIEW_DETAILS:
      return {
        ...state,
        review_details: action.data,
      };

    case types.LOAD_REVIEW_DETAILS_SCORES:
      return {
        ...state,

        review_details_scores: action.data,
      };

    case types.LOAD_REVIEW_PERFORMANCE:
      return {
        ...state,
        review_performance: action.data,
      };
    case types.LOAD_REVIEW_CATEGORIES:
      return {
        ...state,
        review_categories: action.data,
      };
    case types.LOAD_REVIEW_IMAGES:
      return {
        ...state,
        review_images: action.data,
      };
    case types.LOAD_USER_PAYMENTS:
      return {
        ...state,
        userPayments: {
          payments: action.data.payments,
          pagination: action.data.pagination,
        },
      };

    case types.GET_WISHLIST:
      return {
        ...state,
        wishlist: {
          properties: action.data.favourites,
          pagination: action.data.pagination,
        },
      };

    case types.GET_NOTIFICATIONS:
      return {
        ...state,
        userNotifications: {
          notifications: action.data.notifications,
          pagination: action.data.pagination,
        },
      };

    case types.ADD_NOTIFICATION:
      return {
        ...state,
        userNotifications: {
          ...state.userNotifications,
          notifications: [action.data, ...state.userNotifications.notifications],
        },
      };

    case types.UPDATE_NOTIFICATION_STATUS:
      return {
        ...state,
        userNotifications: {
          ...state.userNotifications,
          notifications:
            state.userNotifications.notifications?.map((notification) => {
              const notificationIds = action.data.notificationIds;
              const isSeen = action.data.isSeen;

              if (notificationIds.includes(notification.id)) {
                notification.isSeen = isSeen;
              }

              return notification;
            }) ?? [],
        },
      };

    case types.LOAD_SINGLE_RESERVATION:
      return {
        ...state,
        single_reservation: action.data,
      };

    case types.LOAD_DASHBOARD_HOME:
      return {
        ...state,
        dashboardHome: action.data,
      };
    case types.LOAD_CHATS:
      const { isInitial, ...rest } = action.data;
      return {
        ...state,
        dashboardMessages: {
          ...state.dashboardMessages,
          chatsDetails: {
            ...rest,
            chats: [...(!isInitial ? state.dashboardMessages.chatsDetails.chats : []), ...rest.chats],
          },
        },
      };

    case types.LOAD_NEW_MESSAGE:
      const timeStamp = new Date().toISOString();

      const newMessage = {
        id: Math.floor(Math.random() * 1000000000),
        userType: "GUEST_USER",
        message: action.data.message,
        isSeen: false,
        createdAt: timeStamp,
      };

      // state.dashboardMessages.selectedChat.messages.push();

      return {
        ...state,

        dashboardMessages: {
          ...state.dashboardMessages,
          selectedChat: {
            ...state.dashboardMessages.selectedChat,
            messages: [...state.dashboardMessages.selectedChat.messages, newMessage],
          },
        },
      };

    case types.UN_LOAD_NEW_MESSAGE:
      const _messages = state.dashboardMessages.selectedChat.messages;

      // remove the last message
      _messages.pop();

      return {
        ...state,

        dashboardMessages: {
          ...state.dashboardMessages,
          selectedChat: {
            ...state.dashboardMessages.selectedChat,
            messages: _messages,
          },
        },
      };

    case types.UPDATE_MESSAGE_STATUS:
      const _chats = state.dashboardMessages.chatsDetails.chats;

      const _chat = _chats.find((chat) => chat.bookingId === Number(action.data));

      if (_chat) {
        _chat.unseenCount = 0;
      }

      return {
        ...state,
        dashboardMessages: {
          ...state.dashboardMessages,
          chatsDetails: {
            ...state.dashboardMessages.chatsDetails,
            chats: _chats,
          },
        },
      };

    case types.UPDATE_CHAT_LIST_ITEM:
      // get the item using booking id and increment the unseen count by the count given and move that to the first position
      const _chatList = state.dashboardMessages.chatsDetails.chats;

      let _chatItem = null;

      const message = action.data.message;
      const bookingId = message.bookingDetails.id;

      // remove the chat item from the list and add it to the first position
      const _filteredChatList = _chatList.filter((chat) => {
        if (chat.bookingId !== bookingId) {
          return true;
        } else {
          _chatItem = { ...chat };
          return false;
        }
      });

      if (!_chatItem) {
        _chatItem = {
          bookingId,
          unseenCount: 0,
          propertyDetails: message.propertyDetails,
        };
      }

      _chatItem.unseenCount += action.data.count;

      const _updatedChatList = [_chatItem, ..._filteredChatList];

      return {
        ...state,
        dashboardMessages: {
          ...state.dashboardMessages,
          chatsDetails: {
            ...state.dashboardMessages.chatsDetails,
            chats: _updatedChatList,
          },
        },
      };

    default:
      return state;
  }
}
